module.exports = __webpack_public_path__ + "static/img/4521_phase_function_Paper_Points.46524d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4521_phase_function_Paper_Points.png
// module id = gMeE
// module chunks = 0